export function schema_pdf_extract() {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
			align: {
				title: "Alignement des zones",
				default: true,
				type: ["boolean", 'number']
			},
			csv_col_name: {
				title: "Colonne des noms de fichiers (si CSV en entrée)",
				type: "string",
				default: "name",
			},
			csv_col_url: {
				title: "Colonne des URLs (si CSV en entrée)",
				type: "string",
				default: "url",
			},
			csv: {
				default: false,
				type: "boolean",
				format: "checkbox"
			},
			group_by_page: {
				title: "Réunir par page",
				default: false,
				type: "boolean",
				format: "checkbox",
				watch: { enable: "csv" },
				options: { dependencies: { csv: true } },
			},
			group_by_page_json: {
				title: "Texte en tableau JSON (sinon séparé par |)",
				default: false,
				type: "boolean",
				format: "checkbox",
				watch: { enable: "group_by_page" },
				options: { dependencies: { group_by_page: true } },
			},
			csv_columns: {
				title: "Colonnes du CSV",
				type: "object",
				watch: { enable: "csv" },
				options: { dependencies: { csv: true } },
				properties: {
					col_text: {
						title: "text",
						default: true,
						type: "boolean",
						format: "checkbox",
					},
					col_numero_page: {
						title: "numero_page",
						default: true,
						type: "boolean",
						format: "checkbox",
					},
					col_source_name: {
						title: "source_name",
						default: false,
						type: "boolean",
						format: "checkbox",
					},
					col_source_url: {
						title: "source_url",
						default: false,
						type: "boolean",
						format: "checkbox",
					},
					col_position: {
						title: "position",
						default: true,
						type: "boolean",
						format: "checkbox",
					},
					col_position_simplifie: {
						title: "position simplifiée (t:...|l:...|b:...|r:...)",
						default: false,
						type: "boolean",
						format: "checkbox",
						watch: { enable: "csv_columns.col_position" },
						options: { dependencies: { "csv_columns.col_position": true } },
					},
					col_font_size: {
						title: "font-size",
						default: false,
						type: "boolean",
						format: "checkbox",
					},
					col_font_color: {
						title: "font-color",
						default: false,
						type: "boolean",
						format: "checkbox",
					},
					col_background_color: {
						title: "background_color",
						default: false,
						type: "boolean",
						format: "checkbox",
					},
					col_html: {
						title: "html",
						default: false,
						type: "boolean",
						format: "checkbox",
					},
					col_id: {
						title: "id",
						default: false,
						type: "boolean",
						format: "checkbox",
					},
					col_placement: {
						title: "placement",
						default: false,
						type: "boolean",
						format: "checkbox",
					},
				},
			},
			csv_only: {
				title: "CSV uniquement (sans HTML et images)",
				default: false,
				type: "boolean",
				format: "checkbox",
				watch: { enable: "csv" },
				options: { dependencies: { csv: true } },
			},
			csv_single_file: {
				title: "Enregistrer toutes les lignes dans un seul fichier data.csv",
				default: false,
				type: "boolean",
				format: "checkbox",
				watch: { enable: "csv" },
				options: { dependencies: { csv: true } },
			},
			convert_json: {
				title: "Conversion en json",
				default: true,
				type: "boolean",
				format: "checkbox",
				default: true,
			},
			rotate_90: {
				title: "Rotation à 90°",
				default: true,
				type: "boolean",
				format: "checkbox",
				default: false,
			},
			rotate_180: {
				title: "Rotation à 180°",
				default: true,
				type: "boolean",
				format: "checkbox",
				default: false,
			},
			rotate_270: {
				title: "Rotation à 270°",
				default: true,
				type: "boolean",
				format: "checkbox",
				default: false,
			},
		},
	};
}
